module.exports = __webpack_public_path__ + "stokke_square-569591f6c9dd1020894c3bde542d5782.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/stokke_square.png
// module id = 1190
// module chunks = 1 2